import { RavioliCommonContent } from "../../../../modules/content/components/RavioliCommonContent/RavioliCommonContent";
import { RavioliMedia } from "../../../../modules/content/components/RavioliMedia/RavioliMedia";
import { RavioliSection } from "../../../../modules/content/components/RavioliSection/RavioliSection";
import type { IImageBlockProps } from "./ImageBlock.props";

export const ImageBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
}: IImageBlockProps) => {
  if (!image) return null;

  return (
    <RavioliSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8 md:gap-12">
        <RavioliCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <RavioliMedia
          aspectRatio={image.aspectRatio}
          className="border border-primary bg-collection p-2 shadow-ravioli-action-lg"
          media={image.image}
          sizes="(min-width: 1280px) 1184px, calc(100vw - 48px)"
        />
      </div>
    </RavioliSection>
  );
};

ImageBlock.displayName = "Block::ImageBlock";
